'use client'

import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { i18n } from '../i18n-config'
import { setCookie, getCookie, getCookies } from 'cookies-next';
import { FaGlobeAsia } from "react-icons/fa";
import { Listbox, Transition } from '@headlessui/react'
import { useRouter } from 'next/navigation'

export default function LocaleSwitcher({ language }) {
  const router = useRouter()

  const [currentLocale, setCurrentLocale] = useState(language)
  const [selected, setSelected] = useState(language)
  const [isOpen, setIsOpen] = useState(false)
  const pathName = usePathname()

  const redirectedPathName = (locale) => {
    const languages = ['en', 'cn', 'th', 'ru']

    if (!pathName) return '/'
    if (languages.includes(pathName.split('/')[1])) {
      const segments = pathName.split('/')
      segments[1] = locale
      return segments.join('/')
    } else {
      return `/${locale}` + pathName
    }
  }

  // console.log('hu '+ getCookie('NEXT_LOCALE'))
  // console.log('hu ' + currentLocale)
  const setCookieByRoute = () => {
    const languages = ['en', 'cn', 'th', 'ru']
    let langCookie = getCookie('NEXT_LOCALE')
    if (!pathName) return '/'
    const segments = pathName.split('/')
    if (languages.includes(segments[1]) && (langCookie !== undefined && langCookie !== segments[1])) {
      setCookie('NEXT_LOCALE', segments[1]);
      setSelected(segments[1])
      router.refresh()
    }
  }

  const langList = i18n.locales

  useEffect(() => {
    const triggerLangChange = () => {
      setCookieByRoute()
    }
    triggerLangChange()
  }, [])
  
  
  // setCookieByRoute()

  const setLocaleCookie = (localeValue) => {
    setCookie('NEXT_LOCALE', localeValue);
    setSelected(localeValue)
    router.refresh()
  }

  const toggleOpen = () => {
    setIsOpen(!isOpen)
    // console.log('clicked')
    // console.log(isOpen)
  }
  
  return (
    <>
      {langList.length > 2 ? (
        <div className="relative z-[100]">
          <Listbox value={selected} onChange={setSelected} className='z-[100] mr-3'>
            <div className="z-[100]">
              <Listbox.Button className="cursor-pointer text-light text-center border-[1px] border-light border-solid hover:border-mainhover hover:text-mainhover hover:shadow-sm hover:shadow-mainhover duration-300 p-1 flex items-center rounded-full">
                <FaGlobeAsia className='ml-2' color='white'/><span className="mx-2 truncate text-light text-md">{selected !== 'cn' ? selected.toUpperCase() : '中文'}</span>
              </Listbox.Button>
                <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-[80px] rounded-xl overflow-hidden bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none text-sm">
                {i18n.locales.map((locale) => {
                  if (locale !== 'default') {
                    return (
                    <Listbox.Option
                      key={locale}
                      className={({ active }) =>
                        `z-[100] cursor-default select-none ${
                          active ? 'text-light bg-maincolor' : 'text-maincolor'
                        }`
                      }
                      value={locale}
                    >
                      {({ selected }) => (
                        <>
                              <Link key={locale} onClick={() => setLocaleCookie(locale)} href={redirectedPathName(locale)}>
                                  <div className='text-center text-sm w-[80px]  px-4 py-2 rounded-md  hover:text-light '>
                                    {locale == 'en' && 'English'}
                                    {locale == 'th' && 'ไทย'}
                                    {locale == 'cn' && '中文'}
                                    {locale == 'ru' && 'русский'}
                                  </div>
                              </Link>
                        </>
                      )}
                    </Listbox.Option>
                    ) 
                  }
                })}
                </Listbox.Options>
            </div>
          </Listbox>
        </div>
      ) : null}
    </>
  )
}